<script setup>
import {
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/vue/dist/esm/components/dropdown/index.js";
import { CAvatar } from "@coreui/vue/dist/esm/components/avatar/index.js";
// eslint-disable-next-line import/no-named-as-default
import CIcon from "@coreui/icons-vue";
import { useI18n } from "vue-i18n";
import { useUserStore } from "~/stores/user.js";
import { useModuleStore } from "~/stores/module.js";
import { useTabStore } from "~/stores/tab.js";
import { getImgUrlByTokens } from "~/composables/file";
const { t } = useI18n();

const userStore = useUserStore();
const tabStore = useTabStore();
let user = reactive(userStore.getUser);

function handleUserInfo(e) {
  e.stopPropagation();
  e.preventDefault();
}
function signOut() {
  const { clearTokens } = useAuth();
  clearTokens();

  const userStore = useUserStore();
  userStore.setUser(undefined);
  tabStore.setSelectedTab(undefined);
  tabStore.setTabs([]);
  delete localStorage.openedTabs;
  delete localStorage.visitedRoutes;
  if (sessionStorage) {
    delete sessionStorage["profile.lastVerifiedAt"];
  }
  const moduleStore = useModuleStore();
  moduleStore.flushAllModuleStacks();
  makeToast(t("result.message.signed_out"));
  navigateTo("/login?from=v3");
}
const showProfile = ref(true);
watch(
  () => userStore.getUser,
  () => {
    user = userStore.getUser;
    showProfile.value = false;
    nextTick(() => {
      showProfile.value = true;
    });
  },
  {
    immediate: true,
    deep: true,
  },
);
</script>

<template>
  <CDropdown placement="bottom-end" variant="nav-item">
    <CDropdownToggle class="py-0 pe-0" :caret="false">
      <CAvatar
        v-if="showProfile"
        :key="
          'profile-image-' +
          getImgUrlByTokens(
            user.profileImageTokens,
            '/assets/img/empty-image-user.png',
          )
        "
        :src="
          getImgUrlByTokens(
            user.profileImageTokens,
            '/assets/img/empty-image-user.png',
          )
        "
        size="md"
      />
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
      <div
        v-if="user"
        class="user-info text-center"
        @click="handleUserInfo($event)"
      >
        <CAvatar
          v-if="showProfile"
          :src="
            getImgUrlByTokens(
              user.profileImageTokens,
              '/assets/img/empty-image-user.png',
            )
          "
          size="md"
        /><br />
        <span class="user-name">{{ user.nm }}<br /></span>
        <span v-if="user.email" class="user-email">{{ user.email }}<br /></span>
        <span class="user-login-id">{{ user.loginId }}</span>
        <div
          v-if="user.organizations && user.organizations.length"
          class="user-organizations"
        >
          <div
            v-for="(organization, organizationIndex) in user.organizations"
            :key="'organization-' + organizationIndex"
            class="user-organization"
          >
            {{ organization.nm }}
          </div>
        </div>
      </div>
      <CDropdownDivider />
      <!-- CDropdownHeader
        component="h6"
        class="bg-body-secondary text-body-secondary fw-semibold mb-2 rounded-top"
      >
        Account
      </CDropdownHeader>
      <CDropdownItem>
        <CIcon icon="cil-bell" /> Updates
        <CBadge color="info" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-envelope-open" /> Messages
        <CBadge color="success" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-task" /> Tasks
        <CBadge color="danger" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-comment-square" /> Comments
        <CBadge color="warning" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownHeader
        component="h6"
        class="bg-body-secondary text-body-secondary fw-semibold my-2"
      >
        Settings
      </CDropdownHeader>
      <CDropdownItem> <CIcon icon="cil-user" /> Profile </CDropdownItem>
      <CDropdownItem> <CIcon icon="cil-settings" /> Settings </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-dollar" /> Payments
        <CBadge color="secondary" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownItem>
        <CIcon icon="cil-file" /> Projects
        <CBadge color="primary" class="ms-auto">{{ itemsCount }}</CBadge>
      </CDropdownItem>
      <CDropdownDivider />
      <CDropdownItem>
        <CIcon icon="cil-shield-alt" /> Lock Account
      </CDropdownItem -->
      <CDropdownItem role="button" @click="navigateTo('/userProfile/')">
        <CIcon icon="cil-user" /> {{ $t("common.button.user_profile") }}
      </CDropdownItem>
      <CDropdownItem role="button" @click="signOut($event)">
        <CIcon icon="cil-lock-locked" /> {{ $t("common.button.sign_out") }}
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<style scoped>
.user-name {
  font-size: 1rem;
}
.user-email {
  font-size: 0.8rem;
}
.user-login-id {
  font-size: 0.9rem;
}
.user-info {
  padding: 0.5rem;
}
.avatar >>> img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.user-organizations {
  margin-top: 20px;
}
.user-organization {
  color: #999999;
}
</style>
